import i18n from '../language/index'
import PersonBase from './row_y';
import Store from '../vuex/store';
import Cookies from 'js-cookie';
import Router from '../router';
import {
  get_anchor,
} from '@/api/app';
export default class Person_J_Templet extends PersonBase {
  constructor(...args) {
    super(...args);
    let that = this;
    this.timer = null;
  }
  clickTime(fun1,fun2){
    console.log(this.timer)
    if(this.timer!==null){
      //双击
      clearTimeout(this.timer);
      this.timer=null;
      if(typeof fun2 === 'function'){
        fun2();
      }
    }else{
      //单击
      this.timer = setTimeout(()=>{
        if(typeof fun1 === 'function'){
          fun1();
        }
        clearTimeout(this.timer);
        this.timer = null;
      },500)
    }
  }
  //光标选中
  set_focus(widgets_id) {
    console.log('focus')
    $('#editDiv' + widgets_id).focus()
      $('#u' + widgets_id)
        .find('.contentPart')
        .addClass('focusDiv');
    // let el = document.querySelector('#editDiv' + widgets_id)
    // el.focus();
    // if ($.support.msie) {
    //   var range = document.selection.createRange();
    //   this.last = range;
    //   range.moveToElementText(el);
    //   range.select();
    //   document.selection.empty(); //取消选中
    // } else {
    //   var range = document.createRange();
    //   range.selectNodeContents(el);
    //   range.collapse(false);
    //   var sel = window.getSelection();
    //   sel.removeAllRanges();
    //   sel.addRange(range);
    // }
    // let el = document.querySelector('#editDiv' + widgets_id)
    // var range = document.createRange();
    // range.selectNodeContents(el);
    // range.collapse(false);
    // var sel = window.getSelection();
    // sel.removeAllRanges();
    // sel.addRange(range);
    // )
    // // el.focus();
    // console.log(222333444)
    // el.click();
    // if ($.support.msie) {
    //   var range = document.selection.createRange();
    //   this.last = range;
    //   range.moveToElementText(el);
    //   range.select();
    //   document.selection.empty(); //取消选中
    // } else if($('#u' + widgets_id + ' .edit-div.focus').length == 0){
    //   var range = document.createRange();
    //   range.selectNodeContents(el);
    //   range.collapse(false);
    //   var sel = window.getSelection();
    //   sel.removeAllRanges();
    //   sel.addRange(range);
    // }
    // $('#u' + widgets_id + ' .edit-div').toggleClass('focus')
  }
  //对象数组去重
  filterArray(arr1,arr2,param,tipType = 0) {
    const res = new Map();
    let arr = arr1.concat(arr2)
    let reArray = arr.filter((arr) => !res.has(arr[param]) && res.set(arr[param], 1));
    if(tipType === 0 && arr.length > reArray.length ){
      this.p_$message.warning({
        showClose: true,
        message: i18n.t('base_row_jcp_1918')
      });
    }
    return reArray
  }
  active_anchor(type,id,path) {
    if (type === 'cur_page') {
      //本页面锚点跳转逻辑
      //添加本页面锚点是否存在的判断
      if($('[anchor-id="' + id + '"]').length==0){
        this.p_$message.warning({
          showClose: true,
          message: i18n.t('base_row_jcp_1919')
        });
      }else{
        this.animateFn(id);
      }
    } else {
      if(this.amp_no_make()){
        return
      }
      this.get_anchorData(id,path)
    }
  }

  //所有页面锚点数据载入
  get_anchorData(anchor_id,path) {
    let that = this
    let id = ''
    get_anchor()
      .then(res => {
        if (res.code === 200) {
          let anchor_data = res.data
          let navID = ''
          for (let i in anchor_data) {
            if (Array.isArray(anchor_data[i])) {
              anchor_data[i].map(e => {
                //判断锚点是否还在
                if (e.id === anchor_id) {
                  id = anchor_id
                }
              })
            }
          }
          Store.commit('anchor/SET_allAnchorList', anchor_data);
          //跨页面锚点跳转
          if (id) {
            Cookies.set('anchor_id_wm', id);
            Router.push({
              path: path,
            })
            Store.commit('app/set_now_page', path);
            this.p_init(() => {
              let getID = Cookies.get('anchor_id_wm');
              this.animateFn(getID);
            });
          }else{
              this.p_$message.warning({
                showClose: true,
                message: i18n.t('base_row_jcp_1919')
              });
          }
        } else {
          this.p_$message.error(res.message);
        }
      })
      .catch(error => {
        this.p_$message.error(error)
      });
  }

  animateFn(id) {
    if (id) {
      let offsetTop = $('[anchor-id="' + id + '"]').offset().top;
      //顶部开启固定
      if (Store.state.myRender.common.fixed_header == 'true') {
        // 固定顶部有两种不同的设置：整个顶部、导航所在通栏  只影响pc,移动端两种设置表现一致。
        // fixed_height: 'all', //all:整个顶部 system：导航所在系统栏目
        // 后来有一个新增需求，设置顶部最小高度，会在pc端显示移动端的导航
        if (isMobileHeader() || Store.state.myRender.common.fixed_height === 'all') {
          offsetTop = offsetTop - $('.layout_header').height()
        } else {
          offsetTop = offsetTop - $('.layout_header .layout_row.system_row').height()
        }
      }


      function isMobileHeader() {
        return $('.myheader  .mobile_header').length
      }

      if (Store.state.app.view_pattern === 'pc') {
        offsetTop = offsetTop - $('.topBar').height()
        $('html,body').animate({scrollTop: `${offsetTop}px`}, 200);
      } else {
        offsetTop = offsetTop - $('.layout_header').offset().top
        $('.mb_body_view').animate({scrollTop: `${offsetTop}px`}, 200);
      }
    }
  }

  module_isShow(radioName) {
    Store.state.myRender.common.setting[radioName] = false;
    this.p_$message({
      showClose: true,
      type: 'warning',
      message: i18n.t('base_row_jcp_1920')
    });
  }
  //页面跳转逻辑
  toPage(item){
    if (item.module === 'product'
      || item.module === 'case'
      || item.module === 'help'
      || item.module === 'article'
      || item.module === 'video'
      || item.module === 'download') {
      if (item.isopenwindow === 'true') {
        let routeUrl = Router.resolve({
          path: item.theme_name,
          query: { typeId: item.tid, name: item.name }
        });
        window.open(routeUrl.href, '_blank');
      } else {
        console.log(item)
        if(item.module == "product"){
          Router.push({
            path: item.theme_name,
            query: { id: item.tid, name: item.name }
          });
        }else{
          Router.push({
            path: item.theme_name,
            query: { typeId: item.tid, name: item.name }
          });
        }
      }
    } else if (item.module === 'anchor') {
      let link = item.theme_name.split('#');
      let anchorType = 'other_page';
      if (link[0] == '/') link[0] = 'index:index';
      let id = link[1];
      let path = '';
      let urlList = Store.state.app.websiteSection;
      urlList.map(e => {
        if (e.module == link[0]) {
          path = e.routerPath;
        }
        if (e.routerPath === Store.state.app.now_page && e.module == link[0]) {
          anchorType = 'cur_page';
        }
      });
      if (!path) {
        this.p_$message.warning({
          showClose: true,
          message: i18n.t('base_row_jcp_1921')
        });
        return false;
      }
      this.active_anchor(anchorType, id, path);
    } else if (!item.module) {
      //链接
      if (item.isopenwindow === 'true') {
        window.open(item._link, '_blank');
      } else {
        location.href = item._link;
      }
    } else {
      if (item.isopenwindow === 'true') {
        let routeUrl = Router.resolve({
          path: item.theme_name
        });
        window.open(routeUrl.href, '_blank');
      } else {
        Router.push({
          path: item.theme_name
        });
      }
    }
  }
  checkBorderRadiusValue(typeValue){
    let borderRadius = {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    }
    if(typeof typeValue.borderRadius == 'undefined'){
      this.p_$set(typeValue,'borderRadius',borderRadius);
    }
  }
  checkSummaryValue(typeValue){
    if(typeof typeValue.summary == 'undefined'){
      this.p_$set(typeValue,'summary','');
    }
  }
  checkLockTypeValue(typeValue){
    if(typeof typeValue.lockType == 'undefined'){
      this.p_$set(typeValue,'lockType','false');
    }
  }
  checkMarginRightValue(typeValue){
    let marginRight = {
      radio_val: 'default',
      default: {
        value: 30,
      },
      custom: {
        value: 30,
      }
    }
    if(typeof typeValue.marginRight == 'undefined'){
      this.p_$set(typeValue,'marginRight',marginRight);
    }
  }
  checkChildStyleValue(typeValue){
    if(typeof typeValue.childStyleType == 'undefined'){
      this.p_$set(typeValue,'childStyleType','type_0');
    }
  }
  checkNoteValue(typeValue){
    if(typeof typeValue.note == 'undefined'){
      this.p_$set(typeValue,'note','');
    }
  }
  checkfontStyle(typeValue){
    let fontStyle = {
      radio_val: 'custom',
      default: {
        lineHeight: i18n.t('view_back_top_edit_103'),
        fontSize: 30,
        fsWeight: 'normal',
        fsItalics: 'normal',
        fontStyle: '',
        fontUnderline: 'none',
        fontFamily: 'Arial',
        titleColor: 'rgba(51, 51, 51,1)',
        textAlign: 'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        lineHeight: i18n.t('view_back_top_edit_103'),
        fontSize: 30,
        fsWeight: 'normal',
        fsItalics: 'normal',
        fontStyle: '',
        fontUnderline: 'none',
        fontFamily: 'Arial',
        titleColor: 'rgba(51, 51, 51,1)',
        textAlign: 'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    }
    if(typeof typeValue.fontStyle == 'undefined'){
      this.p_$set(typeValue,'fontStyle',fontStyle);
    }
  }
}



// WEBPACK FOOTER //
// ./src/base/row_jcp.js